import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getAvailablePartners(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.PARTNERS,dtConfig[ModulesMap.PARTNERS].getAvailablePartners,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getBasedPartners(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.PARTNERS,dtConfig[ModulesMap.PARTNERS].getBasedPartners,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedPartners(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.PARTNERS,dtConfig[ModulesMap.PARTNERS].getExtendedPartners,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getFullPartners(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.PARTNERS,dtConfig[ModulesMap.PARTNERS].getFullPartners,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

export default {
	getAvailablePartners,
	getBasedPartners,
	getExtendedPartners,
	getFullPartners,
}
